import React from 'react';
import { connect } from 'react-redux';

// Components
import { Typography } from '@americanexpress/aqx-components';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';

// selectors
import { getisTier2Offer } from 'page_modules/business-pdp/redux';
import { getDefaultTier1OfferBadgeText } from '../redux';
import { isPznDataLoaded as getIsPznDataLoaded } from 'src/universal/redux/pznData';
import { getOfferStylingDtm } from 'src/universal/utils/offerStyling';

// styles
import styles from '../__styles__/defaultOfferBadge.scss?modules';

const DefaultOfferBadge = ({
  isTier2Offer,
  offerBadgeText,
  isPznDataLoaded,
  offerStylingRibbonDtm
}) => {
  if (isTier2Offer || !isPznDataLoaded) return null;

  const lazyLoadCallback = () => {
    sendDTMCustomEvent(offerStylingRibbonDtm);
  };

  return (
    <>
      <LazyScrollMetricTracker
        callBackFunction={lazyLoadCallback}
        startTrackingAfterPznArrival={true}
      />
      <div className={styles.offerBadgeContainer}>
        <Typography className={styles.offerBadgeText}>{offerBadgeText}</Typography>
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    isTier2Offer: getisTier2Offer(state),
    offerBadgeText: getDefaultTier1OfferBadgeText(state),
    isPznDataLoaded: getIsPznDataLoaded(state),
    offerStylingRibbonDtm: getOfferStylingDtm(state, ownProps.shortName)
  };
};

export default connect(mapStateToProps)(DefaultOfferBadge);
